import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";
import { jsPDF } from "jspdf";
import { FaWhatsapp, FaFacebook, FaInstagram, FaShareAlt } from "react-icons/fa";
import { Download } from "lucide-react";
import "./style.css";

import Image1 from "../../Assets/Lakshmi Praba/1_1_11zon.jpg";
import Image2 from "../../Assets/Lakshmi Praba/2_2_11zon.jpg";
import Image3 from "../../Assets/Lakshmi Praba/3_3_11zon.jpg";
import Image4 from "../../Assets/Lakshmi Praba/4_4_11zon.jpg";
import Image5 from "../../Assets/Lakshmi Praba/6_5_11zon.jpg";
import Image6 from "../../Assets/Lakshmi Praba/7_6_11zon.jpg";
import Image7 from "../../Assets/Lakshmi Praba/8_7_11zon.jpg";
import Image8 from "../../Assets/Lakshmi Praba/9_8_11zon.jpg";
import Image9 from "../../Assets/Lakshmi Praba/10_9_11zon.jpg";
import Image10 from "../../Assets/Lakshmi Praba/11_10_11zon.jpg";
import Image11 from "../../Assets/Lakshmi Praba/12_11_11zon.jpg";
import Image12 from "../../Assets/Lakshmi Praba/13_12_11zon.jpg";
import Image13 from "../../Assets/Lakshmi Praba/14_13_11zon.jpg";
import Image14 from "../../Assets/Lakshmi Praba/15_14_11zon.jpg";
import Image15 from "../../Assets/Lakshmi Praba/16_15_11zon.jpg";
import Image16 from "../../Assets/Lakshmi Praba/17_16_11zon.jpg";
import Image17 from "../../Assets/Lakshmi Praba/18_17_11zon.jpg";
import Image18 from "../../Assets/Lakshmi Praba/19_18_11zon.jpg";
import Image19 from "../../Assets/Lakshmi Praba/20_19_11zon.jpg";
import Image20 from "../../Assets/Lakshmi Praba/21_20_11zon.jpg";
import Image21 from "../../Assets/Lakshmi Praba/22_21_11zon.jpg";
import Image22 from "../../Assets/Lakshmi Praba/23_22_11zon.jpg";
import Image23 from "../../Assets/Lakshmi Praba/24_23_11zon.jpg";
import Image24 from "../../Assets/Lakshmi Praba/25_24_11zon.jpg";
import Image25 from "../../Assets/Lakshmi Praba/26_25_11zon.jpg";
import Image26 from "../../Assets/Lakshmi Praba/27_26_11zon.jpg";
import Image27 from "../../Assets/Lakshmi Praba/28_27_11zon.jpg";
import Image28 from "../../Assets/Lakshmi Praba/29_28_11zon.jpg";
import Image29 from "../../Assets/Lakshmi Praba/30_29_11zon.jpg";
import Image30 from "../../Assets/Lakshmi Praba/31_30_11zon.jpg";
import Image31 from "../../Assets/Lakshmi Praba/32_31_11zon.jpg";
import Image32 from "../../Assets/Lakshmi Praba/33_32_11zon.jpg";
import Image33 from "../../Assets/Lakshmi Praba/34_33_11zon.jpg";
import BlankPage from "../../Assets/COMPRESSED/New Project.jpg";

const SkeletonLoader = () => (
  <div className="min-h-screen bg-[#f5f5f0] flex items-center justify-center">
    <div className="flex gap-2 animate-pulse">
      <div className="w-[300px] h-[450px] bg-gray-200 rounded-lg" />
      <div className="w-[300px] h-[450px] bg-gray-100 rounded-lg hidden md:block" />
    </div>
  </div>
);

const LakshmiMagazine = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bookRef = useRef(null);
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const isMobile = windowDimensions.width <= 768;

  const allPages = [
    { image: BlankPage },
    { image: Image1 },
    { image: Image2 },
    { image: Image3 },
    { image: Image4 },
    { image: Image5 },
    { image: Image6 },
    { image: Image7 },
    { image: Image8 },
    { image: Image9 },
    { image: Image10 },
    { image: Image11 },
    { image: Image12 },
    { image: Image13 },
    { image: Image14 },
    { image: Image15 },
    { image: Image16 },
    { image: Image17 },
    { image: Image18 },
    { image: Image19 },
    { image: Image20 },
    { image: Image21 },
    { image: Image22 },
    { image: Image23 },
    { image: Image24 },
    { image: Image25 },
    { image: Image26 },
    { image: Image27 },
    { image: Image28 },
    { image: Image29 },
    { image: Image30 },
    { image: Image31 },
    { image: Image32 },
    { image: Image33 },
    { image: BlankPage },
  ];

  const displayPages = isMobile ? allPages.slice(1, -1) : allPages;
  const pdfPages = allPages.slice(1, -1);

  useEffect(() => {
    const handleResize = () =>
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    setShareUrl(window.location.href);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const imagePromises = displayPages.map(
      (page) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = reject;
          img.src = page.image;
        })
    );
    Promise.all(imagePromises).then(() => setImagesLoaded(true));
  }, [displayPages]);

  const generatePDF = async () => {
    setIsGeneratingPDF(true);
    const pdf = new jsPDF();
    for (let i = 0; i < pdfPages.length; i++) {
      if (i > 0) pdf.addPage();
      await new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const imgProps = pdf.getImageProperties(img);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(img, "JPEG", 0, 0, pdfWidth, pdfHeight);
          resolve();
        };
        img.src = pdfPages[i].image;
      });
    }
    pdf.save("Lakshmi_Praba_E-Magazine.pdf");
    setIsGeneratingPDF(false);
  };

  const shareToWhatsApp = () =>
    window.open(
      `https://api.whatsapp.com/send?text=Homeeframes Issue 02- Lakshmi Praba: ${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  const shareToFacebook = () =>
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  const shareToInstagram = () =>
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => alert("Link copied! Paste it in your Instagram story or post."));
  const shareGeneral = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Lakshmi Praba E-Magazine",
          text: "Check out this amazing magazine!",
          url: shareUrl,
        })
        .catch((error) => console.log("Error sharing", error));
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => alert("Link copied to clipboard!"));
    }
  };

  if (!imagesLoaded) return <SkeletonLoader />;

  return (
    <div className="min-h-screen bg-[#f5f5f0] text-black flex flex-col relative">
      <button
        onClick={() => navigate(-1)}
        className="fixed top-6 left-6 z-50 flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-md border border-black/10 rounded-full text-black hover:bg-black hover:text-white transition-all duration-300 shadow-sm"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        Back
      </button>

      {/* ── HERO TITLE ── */}
      <div className="text-center pt-24 pb-6 px-4">
        <p className="text-xs tracking-[0.3em] uppercase text-black/30 mb-2">
          Homeeframes Magazine
        </p>
        <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-black">
          Lakshmi{" "}
          <span className="text-gray-400">Praba</span>
        </h1>
        <p className="text-black/40 text-sm mt-3 max-w-md mx-auto leading-relaxed">
          A testament to timeless design and structural excellence.
        </p>
        <div className="flex items-center justify-center gap-4 mt-5">
          <span className="w-16 h-px bg-black/10" />
          <span className="text-black/20 text-xs">✦</span>
          <span className="w-16 h-px bg-black/10" />
        </div>
      </div>

      {/* ── FLIPBOOK ── */}
      <main className="flex-1 flex items-center justify-center w-full px-4 py-8 overflow-x-auto">
        <div className="relative flex items-center justify-center w-full">
          {/* Warm glow behind book */}
          <div className="absolute inset-0 -z-10 blur-[80px] opacity-25 bg-amber-100 rounded-full scale-75" />

          {/* Explicit two-page width: 400×2=800px desktop, 300px mobile */}
          <div style={{ width: isMobile ? "300px" : "800px" }}>
            <HTMLFlipBook
              width={isMobile ? 300 : 400}
              height={isMobile ? 450 : 600}
              size="stretch"
              minWidth={300}
              maxWidth={1000}
              minHeight={400}
              maxHeight={1350}
              maxShadowOpacity={0.5}
              mobileScrollSupport={true}
              ref={bookRef}
              className="magazine"
            >
              {displayPages.map((page, index) => (
                <div key={index} className="page">
                  <div className="page-content">
                    <img
                      src={page.image}
                      alt={`Page ${index + 1}`}
                      className="page-image"
                    />
                  </div>
                </div>
              ))}
            </HTMLFlipBook>
          </div>
        </div>
      </main>

      {/* ── BOTTOM ACTION BAR ── */}
      <footer className="w-full border-t border-black/10 bg-white px-6 py-5">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">

          {/* Share buttons */}
          <div className="flex items-center gap-2">
            <span className="text-black/30 text-xs tracking-widest uppercase mr-2">Share</span>
            {[
              { icon: <FaWhatsapp size={16} />, action: shareToWhatsApp, label: "WhatsApp", color: "hover:bg-[#25D366] hover:text-white" },
              { icon: <FaFacebook size={16} />, action: shareToFacebook, label: "Facebook", color: "hover:bg-[#1877F2] hover:text-white" },
              { icon: <FaInstagram size={16} />, action: shareToInstagram, label: "Instagram", color: "hover:bg-[#E1306C] hover:text-white" },
              { icon: <FaShareAlt size={16} />, action: shareGeneral, label: "Share", color: "hover:bg-black/10" },
            ].map(({ icon, action, label, color }) => (
              <button
                key={label}
                onClick={action}
                title={label}
                className={`w-9 h-9 rounded-full bg-black/5 border border-black/10 flex items-center justify-center text-black/60 transition-all duration-200 ${color} hover:scale-105`}
              >
                {icon}
              </button>
            ))}
          </div>

          {/* Download button */}
          <button
            onClick={generatePDF}
            disabled={isGeneratingPDF}
            className="flex items-center gap-2 px-6 py-2.5 rounded-full bg-black text-white font-semibold text-sm tracking-wide hover:bg-gray-800 transition-all duration-200 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          >
            <Download size={15} />
            {isGeneratingPDF ? "Generating PDF…" : "Download PDF"}
          </button>

        </div>
      </footer>

    </div>
  );
};

export default LakshmiMagazine;
